$('.products-texture').on('click', function() {
    $(this).next('.products-photo').removeClass('move').toggleClass('remove');
});
/*
$('.products-photo').on("touchstart",function() {
    $('.products-photo').removeClass('move').removeClass('remove');
    $(this).removeClass('move').toggleClass('remove');
});*/

if ($('.products-texture').hasClass('remove') == false) {
    $('.products-texture').on('mouseenter', function() {
        $('.products-photo').addClass('move');
    }).on('mouseleave', function() {
        $('.products-photo').removeClass('move');
    });
};

$('.products-close').on('click', function() {
    $(this).next('.products-comments').toggleClass('small');
    $(this).toggleClass('small');
});
/* .products-track にスクロールがさしかかったら */
if ($('.products-track').length) {
    /* .products-track の縦の長さを取得 */
    var trackHeight = $('.products-track').height();
    var trackStart = $('.products-track').offset().top;
    /* .products-track の中を高さの1/6スクロールしたら */
    $(window).on('scroll', function() {
        if ($(this).scrollTop() > (trackHeight / 8) * 1 + trackStart && $(this).scrollTop() < (trackHeight / 8) * 2 + trackStart) {
            $('.products-slide').removeClass('current');
            $('#products-slide2').addClass('current');
        } else if ($(this).scrollTop() > (trackHeight / 8) * 2 + trackStart && $(this).scrollTop() < (trackHeight / 8) * 3 + trackStart) {
            $('.products-slide').removeClass('current');
            $('#products-slide3').addClass('current');
        } else if ($(this).scrollTop() > (trackHeight / 8) * 3 + trackStart && $(this).scrollTop() < (trackHeight / 8) * 4 + trackStart) {
            $('.products-slide').removeClass('current');
            $('#products-slide4').addClass('current');
        } else if ($(this).scrollTop() > (trackHeight / 8) * 4 + trackStart && $(this).scrollTop() < (trackHeight / 8) * 5 + trackStart) {
            $('.products-slide').removeClass('current');
            $('#products-slide5').addClass('current');
        } else if ($(this).scrollTop() > (trackHeight / 8) * 5 + trackStart) {
            $('.products-slide').removeClass('current');
            $('#products-slide6').addClass('current');
        } else {
            $('.products-slide').removeClass('current');
            $('#products-slide1').addClass('current');
        }
    });
};

$(window).on('scroll', function() {
    if ($(this).scrollTop() > 100 ) {
        if ($('#global-nav').hasClass('open') == false) {
            $('.main-nav').addClass('visible');
        }
    } else {
        if ($('#global-nav').hasClass('open') == false) {
            $('.main-nav').removeClass('visible');
        }
    }
});

/* .main-nav をクリックしたらハンバーガーメニューが開く */
$('.main-nav').on('click', function() {
    $(this).toggleClass('open');
    $('#global-nav').toggleClass('open');
});


/* img mask effect */
$(document).ready(function () {
    $(".js-mask").append("<div class='js-mask-bg'></div>");
    $(window).on('scroll', function () {
        var windowHeight = $(window).height();
        var scrollHeight = $(window).scrollTop();
        $('.js-mask').each(function () {
            var elementOffset = $(this).offset().top;
            if (scrollHeight + windowHeight > elementOffset + 100) {
                $(this).find(".js-mask-bg").addClass('js-mask-anime');
            };
        });
    });
});


/* loading */
$(window).on('load', function () {
    $('#loading-sc').fadeOut(function () {
        $(this).remove();
        AOS.init({
            once: true
        });
    });
});